// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"ScommesseConditionalAccordion_accordionContainer__N_X8w","childrenContainer":"ScommesseConditionalAccordion_childrenContainer__gePWz"};